export const AOV_FLAT_RATE_TYPE = 'flatRate';
export const COMPLETE_YOUR_SET_TYPE = 'completeSet';
